import React from "react"
import PropTypes from "prop-types"
import { Typography } from "antd"
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons"
import styles from "./BookingForm.module.css"
import moment from "moment"
import { enumerateDates } from "../helpers/dateSpan"

const { Text } = Typography

const MetaItem = ({ icon: Icon, text }) => (
  <div className={styles.tripMetaItem}>
    <Icon className={styles.tripMetaIcon} />
    <Text className={styles.tripMetaText}>{text}</Text>
  </div>
)

MetaItem.propTypes = {
  icon: PropTypes.elementType.isRequired,
  text: PropTypes.string.isRequired
}

const TripDetailsCard = ({ booking, bookingSelections, experienceDetail }) => {
  // Prefer the currently selected experience (experienceDetail) over the booking's original trip, so
  // that switching the experience while editing shows the updated details here rather than the old
  // one. Falls back to the booking when the detail hasn't loaded / for unchanged bookings.
  const tripName = experienceDetail?.title || booking?.trip?.title || ""
  const isMultiDay = (experienceDetail?.duration_type || booking?.duration_type) === "multi_day"

  let dateText = ""
  let timeText = ""

  if (isMultiDay) {
    if (bookingSelections?.date) {
      let formattedStart
      let formattedEnd
      if (bookingSelections?.endDate) {
        // Live selection (dynamic multi-day): always reflect what's actually picked in this
        // session rather than the original booking's day count, which may now be stale.
        const dates = enumerateDates(bookingSelections.date, bookingSelections.endDate)
        formattedStart = moment(dates[0] || bookingSelections.date).format("MM/DD/YYYY")
        formattedEnd = moment(dates[dates.length - 1] || bookingSelections.date).format("MM/DD/YYYY")
      } else {
        // Fixed multi-day (no separate endDate concept) — derive the span from the original
        // booking's day count.
        const numDays = booking?.booked_dates?.length || 1
        formattedStart = moment(bookingSelections.date).format("MM/DD/YYYY")
        formattedEnd = moment(bookingSelections.date)
          .add(numDays - 1, "days")
          .format("MM/DD/YYYY")
      }
      dateText = formattedStart === formattedEnd ? formattedStart : `${formattedStart} → ${formattedEnd}`
    }
    timeText = bookingSelections?.timeSlot?.split(" - ")?.[0] || booking?.start_time || ""
  } else {
    dateText = bookingSelections?.date ? moment(bookingSelections.date).format("MM-DD-YYYY") : ""
    timeText = bookingSelections?.timeSlot || ""
  }

  if (!tripName && !dateText && !timeText) return null

  return (
    <>
      {tripName && <div className={styles.tripName}>{tripName}</div>}
      {(dateText || timeText) && (
        <div className={styles.tripMetaRow}>
          {dateText && <MetaItem icon={CalendarOutlined} text={dateText} />}
          {timeText && <MetaItem icon={ClockCircleOutlined} text={timeText} />}
        </div>
      )}
    </>
  )
}

TripDetailsCard.propTypes = {
  booking: PropTypes.object,
  bookingSelections: PropTypes.object,
  experienceDetail: PropTypes.object
}

export default TripDetailsCard
